export const BASE_URL = "https://api.weasoccer.com";
export const BASE_WEBSOCKET_URL = "https://api.weasoccer.com";
export const WEB_STREAMING_URL = "https://live.weasoccer.com";
// if (process.env.NODE_ENV === 'development') {
//   BASE_URL = 'http://ec2-18-217-30-15.us-east-2.compute.amazonaws.com:3000/api/v1'
// }
